// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2qNru","text":"SelectPayment_text__2v-3H","title":"SelectPayment_title__1rCjv","btn":"SelectPayment_btn__3SBle"};